import React from "react";
import { Grid, InputAdornment, MenuItem, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import "./addEmployeeModal.scss";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import DroupdownIcon from "../../../../assets/common-imgs/dropdown-icon.svg";
import {useNavigate } from "react-router-dom";
import { replace } from "formik";

interface IMODAL {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: boolean;
}

const AddEmpolyeeModal: React.FC<IMODAL> = (props) => {
  const [template, setTemplate] = React.useState<any>("");
  const navigate = useNavigate()

  const formSubmitHandler = ()=>{
    navigate("/signin")
    console.log(template, "template data")

    

  }
  return (
    <div className="addEmployee-modal">
      <Modal
        open={props.openModal}
        onClose={() => props.setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="addEmployee-modal-main"
      >
        <Grid
          container
          item
          className="modal"
          xs={11}
          sm={8}
          md={6}
          lg={6}
          xl={5}
        >
          <div className="modal-contant" style={{ width: "100%" }}>
            <div className="modal-header h6 d-flex fw-600 br-8">
              Add a new hire
              <CancelSharpIcon
                sx={{
                  color: "gray",
                  margin: "0 0 0 auto",
                  cursor: "pointer",
                }}
                onClick={() => props.setOpenModal(false)}
              />
            </div>
            <p>
              Here you can choose the new hire flow template that’s the best for
              your new employee. You can always add, view and edit new hire
              flows in “Flows” tab in “Settings”.
            </p>
            <form className="d-flex justify-center" onSubmit={formSubmitHandler}>
              <TextField
                sx={{ margin: "-0 20px" }}
                fullWidth
                select
                SelectProps={{ IconComponent: () => null }}
                value={template}
                name="template"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setTemplate(e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment sx={{ cursor: "pointer" }} position="end">
                      <img src={DroupdownIcon} />
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value={"Pakistan"}>Pakistan</MenuItem>
                <MenuItem value={"United Kingdom"}>United Kingdom</MenuItem>
                <MenuItem value={"India"}>India</MenuItem>
              </TextField>
              <button className="btn  btn-secondary h6" type="submit">
                start
              </button>
            </form>
          </div>
        </Grid>
      </Modal>
    </div>
  );
};

export default AddEmpolyeeModal;
